/* eslint-disable @typescript-eslint/no-unused-vars */
import { Mesh } from '@babylonjs/core/Meshes'
// import { Vector3 } from '@babylonjs/core/Maths/math.vector'
import { BoundingBox } from '@babylonjs/core/Culling/boundingBox'

export function centerMesh (mesh: Mesh) {
  const { max, min } = mesh.getHierarchyBoundingVectors(true, x => x.isVisible)
  const bbox = new BoundingBox(min, max)
  const center = bbox.centerWorld
  mesh.position.subtractInPlace(center)
  mesh.position.x = 0
}
